import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation } from '@tanstack/react-query'

import { Apis } from '@/appSettings'

import { useUrl } from '.'

export const usePoleasEssoxImport = () => {
  const url = useUrl(Apis.poleasEssox)
  
  return useMutation({ mutationFn: (x: { data: FormData }) => apiClient.post<number[]>(`${url}/Import`, x.data).catch(e => { throw e.response.data as { error: string, description?: string} }) })
}